export const messages = {
  en: {
    staffDetailInfo: {
      title: 'Staff Information',
      staffId: 'ID:',
      userName: 'Name:',
      email: 'Email:',
      tel: 'Phone:',
      sex: 'Gender:',
      male: 'Male',
      female: 'Female',
      address: 'Address:',
      relatedOrg: 'Related Organization',
      relatedRoleCommunity: 'Related Roles & Communities',
      staffPrivilege: 'Staff Privileges',
      staffTrack: 'Staff Track',
      org: 'Organization',
      fetchError: 'Failed to fetch staff details',
      fetchOrgError: 'Failed to fetch organization information',
      fetchRoleError: 'Failed to fetch role information',
      fetchPrivilegeError: 'Failed to fetch privilege information'
    }
  },
  zh: {
    staffDetailInfo: {
      title: '员工信息',
      staffId: '编号：',
      userName: '名称：',
      email: '邮箱：',
      tel: '手机：',
      sex: '性别：',
      male: '男',
      female: '女',
      address: '住址：',
      relatedOrg: '关联组织',
      relatedRoleCommunity: '关联角色及小区',
      staffPrivilege: '员工权限',
      staffTrack: '员工轨迹',
      org: '组织',
      fetchError: '获取员工详情失败',
      fetchOrgError: '获取组织信息失败',
      fetchRoleError: '获取角色信息失败',
fetchPrivilegeError: '获取权限信息失败'
    }
  },
  'zh-TW': {
    staffDetailInfo: {
      title: '員工信息',
      staffId: '編號：',
      userName: '名稱：',
      email: '郵箱：',
      tel: '手機：',
      sex: '性別：',
      male: '男',
      female: '女',
      address: '住址：',
      relatedOrg: '關聯組織',
      relatedRoleCommunity: '關聯角色及小區',
      staffPrivilege: '員工權限',
      staffTrack: '員工軌跡',
      org: '組織',
      fetchError: '獲取員工詳情失敗',
      fetchOrgError: '獲取組織信息失敗',
      fetchRoleError: '獲取角色信息失敗',
      fetchPrivilegeError: '獲取權限信息失敗'
    }
  }
}